import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppConfigService } from '@justonweb/core';
import { UnderMaintenanceService } from '@justonweb/under-maintenance';
import { Subscription } from 'rxjs';
import { AppService } from './app.service';
import { isBefore } from 'date-fns';

@Component({
    selector: 'justonweb-login-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  constructor(
    private appService: AppService,
    private titleService: Title,
    private appConfig: AppConfigService,
    private underMaintenanceService: UnderMaintenanceService
  ) {
    let from = new Date(new Date().getFullYear(), 11, 31, 23, 50);
    let until = new Date(new Date().getFullYear() + 1, 0, 1, 5, 50);
    if (isBefore(new Date(), new Date(new Date().getFullYear(), 0, 1, 5, 50))) {
      from = new Date(new Date().getFullYear(), 0, 1, 0, 0);
      until = new Date(new Date().getFullYear(), 0, 1, 5, 50);
    }
    this.underMaintenanceService.activate(from, '/under-maintenance', until, '/');
  }

  ngOnInit() {
    //Add noIndex meta tag when we are in ACC/DEV Environments to stop them from being indexed by searchEngines cfr => https://www.deepcrawl.com/blog/best-practice/noindex-disallow-nofollow/
    if (this.appConfig.isTestEnvironment) {
      let noIndexMetaTag = document.createElement('meta');
      noIndexMetaTag.name = 'robots';
      noIndexMetaTag.content = 'noindex';
      document.getElementsByTagName('head')[0].appendChild(noIndexMetaTag);
    }

    this.subscription.add(this.appService.lang$.subscribe((lang: string) => {
      document.documentElement.lang = lang;
      this.setTitle(lang);
    }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private setTitle(lang: string): void {
    let newTitle: string = '';
    switch (lang) {
      case 'nl':
        newTitle = 'Rechterlijke Bescherming';
        break;

      case 'fr':
        newTitle = 'Protection Judiciaire';
        break;

      case 'de':
        newTitle = 'Gerichtlicher Schutz';
        break;
    }
    this.titleService.setTitle(newTitle);
  }
}
